import { AHIcon, AHWidgetTitle, Box, useWidgetOptions } from "arkh";
import React from "react";

import { BaseWidgetProps } from "../BaseProps";

import { useEvent } from "../useEvent";
import {
  graphql,
  useFragment,
  useSubscribeToInvalidationState,
} from "react-relay";
import { WidgetSignalOverview_widget$key } from "./__generated__/WidgetSignalOverview_widget.graphql";

import { WidgetSignalOverviewContentMedium } from "./WidgetSignalOverviewContentMedium";
import { useSetScrollFocusMutation } from "../Focus/useSetFocusScroll";
import { useSetWidgetFocus } from "../useSetFocus";

export const WidgetSignalOverview = (
  props: {
    widget: WidgetSignalOverview_widget$key;
  } & BaseWidgetProps
) => {
  const widget = useFragment(
    graphql`
      fragment WidgetSignalOverview_widget on WidgetSignalOverview {
        id
        title
        teams {
          id
        }
        ...WidgetSignalOverviewContentMediumPaginated
      }
    `,
    props.widget
  );

  const [fetchKey, setFetchKey] = React.useState(0);
  useSubscribeToInvalidationState([widget.id], () => {
    setFetchKey((fk) => fk + 1);
  });

  const setScroll = useSetScrollFocusMutation(props.storecastId, widget.id);
  const setFocus = useSetWidgetFocus(widget.id, props.storecastId);
  const { background } = useWidgetOptions();

  const onSelectSignal = useEvent((signalId: string) => {
    if (props.mode === "FOCUS" && props.highlightedItemId !== signalId) {
      setFocus(signalId);
    } else {
      props.onEvent?.({
        kind: "Signal",
        signalId,
        widgetId: widget.id,
        teamId: widget.teams?.[0]?.id,
      });
    }
  });

  return (
    <Box style={{ flex: 1, backgroundColor: background }} color="surface">
      <AHWidgetTitle>
        <AHIcon
          type="signal"
          spaceRight="xsmall"
          size="xsmall"
        />
        {widget.title}
      </AHWidgetTitle>

      <WidgetSignalOverviewContentMedium
        shouldDimInactive={
          props.mode === "FOCUS" && !!props.highlightedItemId
        }
        isFocused={props.isFocused}
        interactive={props.interactive}
        highlightedItemId={props.highlightedItemId}
        onPressItem={onSelectSignal}
        setScroll={setScroll}
        widget={widget}
      />
    </Box>
  );
};
